import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import { computed, ref } from 'vue';
import { mdiChevronDown, mdiChevronUp, mdiEye } from '@mdi/js';
import { IObras } from '../../types';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';

interface IProps {
  obra: IObras;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    obra: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check'],
  setup(__props: any) {

const props = __props as {
  obra: IObras;
  isSelecionado: boolean;
};

const store = ConsultaObrasStore();

const showDetalhes = ref(false);





const title = computed(
  () => props.obra.deTipoObra + ' - ' + props.obra?.deTitulo
);

const highlightedDesc = computed(() => props.obra?.highlightedDesc || '');

const detalhes = computed(() =>
  [
    {
      label: 'Localização:',
      value: props.obra?.deLocalizacao,
    },
    {
      label: 'Documento:',
      value: props.obra?.deDocumento,
    },
    {
      label: 'Classificação:',
      value: props.obra?.deClassificacao,
    },
    {
      label: 'Notação do Autor:',
      value: props.obra?.deNotacaoAutor,
    },
    {
      label: 'Localização fixa:',
      value: props.obra?.deLocalizacaoFixa,
    },
  ].filter((item) => !!item.value)
);

const abreVisualizador = () => {
  window.open(`./visualiza/${props.obra.cdObra}/${props.obra.cdTipoObra}`);
};

const itensImpressao = [
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
];

return { __sfc: true,store, showDetalhes, props, title, highlightedDesc, detalhes, abreVisualizador, itensImpressao, CardExpand, SeletorOpcoesImpressão, mdiChevronDown, mdiChevronUp, mdiEye }
}

})